export { default } from "www/pages/terms_of_service/TermsOfService";
